import API from '../../sunwiseAPI';
const ENTITY = 'report-card';
const ENTITY_PAGINATED = 'paginated-reports';

export const create = (data) => API.post(`/api/v1/${ENTITY}/sunpay/`, data);
export const fetchPaginatedData = (project_id, page, page_size, year) =>
    API.get(`/api/v1/${ENTITY_PAGINATED}/sunpay/`, {
        params: { page, page_size, project_id, year },
    });
export const update = (uuid, data) =>
    API.put(`/api/v1/${ENTITY}/${uuid}/sunpay/`, data);
export const deleteItem = (uuid) =>
    API.delete(`/api/v1/${ENTITY}/${uuid}/sunpay/`);
